import { DataGrid } from "@mui/x-data-grid";
import { breadcrumbsActions } from "@store/breadcrumbs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ApplicationPageTemplate from "src/applications/dashboard/components/ApplicationPageTemplate/ApplicationPageTemplate";
import { Box } from "@mui/system";


import styles from "./Assets.module.scss";
import { Chip, Stack, Typography, Switch, Button } from "@mui/material";

import { addNewCountry, fetchAssets, toggelDeleteGiftCountry } from "@store/country-management"
import { showErrorMessage, showSuccessMessage } from "@store/dashboard";
import { setLoading } from '@store/asset-loader';
import AddNewCountryModal from "./AddNewCountryModal";

const Process = () => {
	const imageSize = 150;
	const dispatch = useDispatch();
	const assets = useSelector((state) => state.giftCountryList.countries);

	const [openModal, setOpenModal] = useState(false);
	const [existingFormData, setExistingFormData] = useState(null);

	useEffect(() => {
		dispatch(
			breadcrumbsActions.setBreadcrumbs([
				{ label: "Home", url: "/" },
				{ label: "Country Management", url: "/assets-management" },
			])
		);
		dispatch(fetchAssets());
	}, [dispatch]);

	// const onFileChange = (assetId, event) => {
	// 	console.log(assetId);
	// 	let selectedFile = event.target.files[0];
	// 	dispatch(setLoading(true));
	// 	dispatch(updateAsset({ assetId, selectedFile }))
	// 		.then(() => {
	// 			dispatch(setLoading(false));
	// 			return (dispatch(showSuccessMessage("Asset updated successfully")));

	// 		})
	// 		.catch(function (error) {
	// 			console.log(error);
	// 			//dispatch(showErrorMessage(`Failed to update asset: ${error}`));
	// 		});
	// };
	const handleIsDeletedChange = (id, checked) => {

		const result = window.confirm("Are you sure you want to do this Action, Turning off country might impact mobile catelog list for this country?");
		if (result) {
			console.log(id, checked);
			dispatch(setLoading(true));
			dispatch(toggelDeleteGiftCountry(id))
				.then(() => {
					dispatch(setLoading(false));
					return dispatch(showSuccessMessage("Gift Country updated successfully"));
				})
				.catch(function (error) {
					console.log(error);
					dispatch(showErrorMessage(`Failed to update Gift Country: ${error}`));
				});
		}

	};
	const handleOpenModaladd = () => {
		setOpenModal(true);
	};
	const handleCloseModaladd = () => {
		setExistingFormData(null);

		setOpenModal(false);
	};
	const handleAddNew = async (data) => {
		dispatch(setLoading(true));
		await dispatch(addNewCountry(data)).unwrap()
			.then(() => {
				dispatch(setLoading(false));
				//dispatch(handleCloseModaladd());
				return dispatch(showSuccessMessage("Adding New/Updated successfully"));

			})
			.catch(function (error) {
				console.log("Try Catch called:", error)
				dispatch(setLoading(false));
				dispatch(showErrorMessage(`Failed to update Gift Country: ${error.message}`));
			})


	};
	return (
		<ApplicationPageTemplate title={"Gift Country Management"} description={"Manage Gifing Countries, List , Add , and update Country Details[ Hero Banner, Flag , And Names. As of now Country wil be added with Deteted Flag as it will required extra details and approved by Buisess and Tech Team"} pageReady={true}>
			<Button variant="contained" color="primary" onClick={handleOpenModaladd}>
				Add New
			</Button>
			<AddNewCountryModal isVisible={openModal} onClose={handleCloseModaladd} onCreate={handleAddNew} existingFormData={existingFormData} />

			<DataGrid
				rowHeight={imageSize}
				style={{ background: "white" }}
				rows={assets}
				density="standard"
				disableColumnFilter={true}
				//disableColumnMenu={true}
				disableColumnSelector={true}
				disableDensitySelector={true}
				disableSelectionOnClick={true}
				getRowClassName={({ row }) => styles.AssetsRow}
				getCellClassName={({ row }) => styles.AssetsCell}
				headerHeight={30}
				columns={[
					{
						field: "url",
						headerName: "Banner",
						sortable: false,
						headerAlign: "center",
						align: "center",
						width: imageSize,
						cellClassName: styles.ImageCell,
						renderCell: ({ row }) => (
							<Box
								sx={{
									padding: 0,
									background: "url('" + row.countryBannerList[0].imageUrl + "')",
									width: imageSize - 20 + "px",
									height: imageSize - 20 + "px",
									backgroundSize: "contain",
									backgroundRepeat: "no-repeat",
									backgroundPosition: "center",
									backgroundColor: "#f3f7ee",
									boxShadow: "rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px",
									borderRadius: "5px",
								}}
							></Box>
						),
					},
					{
						field: "Country Flag",
						headerName: "Flag",
						sortable: false,
						headerAlign: "center",
						align: "center",
						width: imageSize,
						cellClassName: styles.ImageCell,
						renderCell: ({ row }) => (
							<Box
								sx={{
									padding: 0,
									background: "url('" + row.flagUrl + "')",
									width: imageSize - 20 + "px",
									height: imageSize - 20 + "px",
									backgroundSize: "contain",
									backgroundRepeat: "no-repeat",
									backgroundPosition: "center",
									backgroundColor: "#f3f7ee",
									boxShadow: "rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px",
									borderRadius: "5px",
								}}
							></Box>
						),
					},
					{
						field: "title",
						headerName: "Title",
						sortable: false,
						headerAlign: "left",
						align: "left",
						width: "30px",
						renderCell: ({ row }) => (
							<Stack sx={{ height: "100%", paddingTop: "40px" }}>
								<Typography variant="h6">Country: {row.fullName}</Typography>
								<Typography variant="body2">Country Short Name : {row.shortName}</Typography>
								<Box mt={1}>
									<Chip label="400*400 For Hero Banner:" sx={{ background: "bisque" }} />
									<Chip label="Rendered aspect ratio:	360∶247" sx={{ background: "bisque" }} />
									<Chip label="File Type: PNG for Hero Banner, SVG for Country Flag" sx={{ background: "bisque" }} />

								</Box>
							</Stack>
						),
						flex: 1,
					},
					{
						field: "isDeleted",
						headerName: "Active/Inactive",
						width: 120,
						renderCell: (params) => <Switch checked={!params.value} onChange={(event) => handleIsDeletedChange(params.id, event.target.checked)} key={params.id} />,
					},
					// {
					// 	field: "Upload",
					// 	headerName: "Update Hero Banner",
					// 	width: 120,
					// 	renderCell: (params: GridCellParams) =>[
					// 		<IconButton color="primary" aria-label="upload picture" component="label">
					//  			<input hidden accept="image/*" type="file" onChange={(event) => onFileChange(params.row.id, event)} key={params.id}/>
					//  			<CloudUploadIcon />
					//  		</IconButton>,
					// 	],

					// },
					// {
					// 	field: "actions",
					// 	type: "actions",
					// 	headerName: "Update Hero Banner",

					// 	getActions: (params) => [
					// 		<IconButton color="primary" aria-label="upload picture" component="label">
					// 			<input hidden accept="image/*" type="file" onChange={(event) => onFileChange(params.row.id, event)} />
					// 			<CloudUploadIcon />
					// 		</IconButton>,
					// 	],
					// },
					{
						field: "actions",
						headerName: "Actions",
						width: 120,
						renderCell: (params) => (
							<Button
								variant="contained"
								color="primary"
								onClick={() => {
									// save changes for this row
									const updatedRowData = { ...params.row };
									console.log("current row", updatedRowData);
									setExistingFormData(updatedRowData);
									setOpenModal(true);
								}}
							>
								Update
							</Button>
						),
					},


				]}
			></DataGrid>
		</ApplicationPageTemplate>
	);
};

export default Process;
